import { createStructuredSelector } from 'reselect';
import { userDataSelector } from '@selectors/global';
import {
  deedLookupModalOpenSelector,
  deedLookupModalModeSelector,
  deedLookupModalStateSelector,
  deedLookupModalDataSelector,
  deedLookupModalPropertyIdSelector,
} from '../../selectors/deed';
import { preferenceSelector } from '../../selectors/global';

export default createStructuredSelector({
  data: deedLookupModalDataSelector,
  modalOpen: deedLookupModalOpenSelector,
  mode: deedLookupModalModeSelector,
  preference: preferenceSelector,
  propertyId: deedLookupModalPropertyIdSelector,
  state: deedLookupModalStateSelector,
  userData: userDataSelector,
});
